import SubHeading from 'e-submission/components/Heading/SubHeading'

export default (hoc) => hoc(SubHeading)
